import BaseRepository from 'Domain/Repositories/BaseRepository/BaseRepository';
import { UserTicket }   from 'Domain/Models';

const config = {
    model: UserTicket,
    baseRoute: '/admin/user-ticket',
    singular: 'ticket',
    plural: 'tickets',
}

class UserTicketRepository extends BaseRepository<UserTicket, typeof config.singular, typeof config.plural> {

  createTickets(data: { eventTicketId: string, amount: number, user: any }) {
    return this.makeRequest({
      path: `${this.baseRoute}/bulk`,
      type: 'POST',
      data,
      callback: this.initializeModels
    });
  }

  downloadTicketPdf(id: string) {
    return this.makeRequest({
      path: `${this.baseRoute}/${id}/download-ticket-pdf`,
      type: 'GET',
      callback: this.downloadFile('application/pdf'),
    });
  }
}

export default new UserTicketRepository(config);
